<div class="p-3">
  <h2 mat-dialog-title>Edit {{ data.selectedType }} Value</h2>

  <mat-dialog-content>
    <form [formGroup]="form">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Value</mat-label>
        <input matInput type="text" formControlName="name" autocomplete="off">
        <mat-error *ngIf="Name?.errors?.['required']">This field is required.</mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">Save</button>
  </mat-dialog-actions>
</div>